import { CSSProperties, ReactNode, useState } from "react";
import { twMerge } from "tailwind-merge";
import { Expandable } from "./Expandable";
import styles from "./ExpandableText.module.css";

class Props {
  className?: string;
  style?: CSSProperties;
  children?: ReactNode;
}
export function ExpandableText({ className, style, children }: Props) {
  const [expanded, setExpanded] = useState(false);

  return (
    <Expandable
      expanded={expanded}
      onClick={() => setExpanded(!expanded)}
      className={twMerge(
        "min-h-[60px] cursor-pointer",
        styles.container,
        expanded && styles.expanded,
        !expanded && "max-h-[60px]",
        className,
      )}
      style={style}
    >
      <pre className={"flex flex-col break-words whitespace-pre-wrap"}>
        {children}
      </pre>
    </Expandable>
  );
}
